import angular from 'angular';
import uiRouter from 'angular-ui-router';
import homeComponent from './home.component';

let homeModule = angular.module('home', [
  uiRouter
])

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";

  $urlRouterProvider.otherwise('/');

  $stateProvider
    .state('main.home', {
      name: "main.home",
      url: '/',
      component: 'home',
      data: {protected: true}
    });
})

.component('home', homeComponent)

.name;

export default homeModule;



// WEBPACK FOOTER //
// ./client/app/components/home/home.js